import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import Login from "./screens/login";
import DashboardLayout from "./DashboardLayout";
import Dashboard from "./screens/dashboard";
import Configuration from "./screens/configuration";
import PowerSplitterMeters from "./screens/power-splitter-meters";
import { PageLoader } from "./components/general/loaders";
import WalletStatement from "./screens/wallet-statement";
import { useAuth } from "./context/authContext";
import ResetPassword from "./screens/reset-password";
import Enroll from "./screens/enroll";

function App() {
  const { user, token, authLoading, profileChecked } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const publicRoutes = ["/", "/reset-password", "/create-account"];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  useEffect(() => {
    if (authLoading || (token && user && !profileChecked)) return;

    if (!token && !isPublicRoute) {
      navigate("/", { replace: true });
      return;
    }

    if (token && user && isPublicRoute) {
      navigate("/dashboard", { replace: true });
    }
  }, [
    token,
    user,
    authLoading,
    profileChecked,
    isPublicRoute,
    navigate,
  ]);

  if (authLoading || (token && user && !profileChecked)) {
    return (
      <div className="flex items-center justify-center h-screen">
        <PageLoader />
      </div>
    );
  }

  return (
    <>
      {!user ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/create-account" element={<Enroll />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="configuration" element={<Configuration />} />
            <Route path="power-splitter-meters" element={<PowerSplitterMeters />} />
            <Route path="dashboard/statement" element={<WalletStatement />} />
            <Route path="*" element={<Dashboard />} />
          </Route>
        </Routes>
      )}
    </>
  );
}

export default App;
